import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

import { pick } from 'utils/object';

import { Office } from '../types';

type OfficeMutationParams = Pick<Office, 'name' | 'address' | 'city' | 'country' | 'state'>;

const mutateProperties: Array<keyof OfficeMutationParams> = [
  'name',
  'address',
  'city',
  'country',
  'state',
];

const validateOffice = (params: OfficeMutationParams): boolean => {
  return mutateProperties.every((prop) => params[prop]);
};

export const officeMutations = getMutations({
  createOffice: {
    action: async (payload: OfficeMutationParams): Promise<Office> => {
      return executeApiCall({
        path: '/offices',
        payload: pick(payload, mutateProperties),
      });
    },

    messages: {
      success: 'team-created-with-success',

      error: 'error-while-creating-team',
    },

    validate: (payload: OfficeMutationParams) => {
      return {
        ok: validateOffice(payload),
      };
    },
  },

  updateOffice: {
    action: async (payload: OfficeMutationParams & { id: string }): Promise<Office> => {
      return executeApiCall({
        path: '/offices',
        method: 'put',
        payload: pick(payload, [...mutateProperties, 'id']),
      });
    },

    validate: (payload: OfficeMutationParams & { id: string }) => {
      return {
        ok: !!payload.id && validateOffice(payload),
      };
    },
  },
});
